import { render, staticRenderFns } from "./NotificationPagination.vue?vue&type=template&id=2f7312ba&"
import script from "./NotificationPagination.vue?vue&type=script&lang=js&"
export * from "./NotificationPagination.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports